import axios from 'axios'
import {API_URL} from '../../../../../../_metronic/helpers'
import type {InvoicePrintPage, InvoicePrintPreference} from './printPagePreference'

// The print page API (MegaPayBackend InvoicePrintPreferenceController), apart from the hook that
// reads it, so tests can replace the requests alone.

const normalizePage = (value: unknown): InvoicePrintPage =>
  value === 'classic' ? 'classic' : 'new'

const normalizePreference = (data: InvoicePrintPreference): InvoicePrintPreference => ({
  companyId: Number(data?.companyId || 0),
  page: normalizePage(data?.page),
  canChange: Boolean(data?.canChange),
  available: data?.available !== false,
  latestInvoice: data?.latestInvoice?.hashCode ? data.latestInvoice : null,
})

export const getInvoicePrintPreference = async (companyId: number, signal?: AbortSignal) => {
  const response = await axios.get<InvoicePrintPreference>(`${API_URL}/invoice-print/preference`, {
    params: {companyId},
    signal,
  })
  return normalizePreference(response.data)
}

export const saveInvoicePrintPreference = async (companyId: number, page: InvoicePrintPage) => {
  const response = await axios.put<InvoicePrintPreference>(`${API_URL}/invoice-print/preference`, {
    companyId,
    page,
  })
  return normalizePreference(response.data)
}

/** The page an invoice's link opens for the signed-in user (its business's page, or the new one). */
export const getInvoicePrintPageForLink = async (hash: string): Promise<InvoicePrintPage> => {
  const response = await axios.get<{page?: string}>(
    `${API_URL}/invoice-print/page/${encodeURIComponent(hash)}`
  )
  return normalizePage(response.data?.page)
}
